import {ImageItem, MenuFormat} from "../MenuDocumentModel";
import {ReactElement} from "react";
import {EditorItem} from "../editorUtils";

export interface ImagePreviewItemProps {
    format: MenuFormat
    image: EditorItem<ImageItem>
}

export function ImagePreviewItem(props: ImagePreviewItemProps): ReactElement {
    return (
        <div className={`flex justify-${props.image.menuItem.align || 'left'}`} style={{height: `${props.image.menuItem.height}mm`}}>
            <img alt="placeholder" className="object-contain h-full" src={props.image.menuItem.url} />
        </div>
    );
}